import { Flame } from "lucide-react";
import { RESTAURANT_NAME, buildWaLink } from "../data/menu";
import WaIcon from "./WaIcon";

export const Footer = () => {
    return (
        <footer
            className="bg-[#1F1A17] text-white pt-14 pb-8"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-center gap-2.5">
                        <span className="w-10 h-10 rounded-full bg-[#D35400] inline-flex items-center justify-center">
                            <Flame className="w-5 h-5" />
                        </span>
                        <span className="font-display text-2xl font-black">
                            {RESTAURANT_NAME}
                        </span>
                    </div>
                    <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-sm">
                        Authentic Arabian Mandi, Hyderabadi Dum Biryani & Mughalai
                        classics — served with love, ordered on WhatsApp.
                    </p>
                </div>

                <div>
                    <h4 className="font-display text-lg font-bold">Explore</h4>
                    <ul className="mt-4 space-y-2 text-sm text-white/70">
                        <li>
                            <a href="#home" className="hover:text-[#FFCBA0]" data-testid="footer-home">
                                Home
                            </a>
                        </li>
                        <li>
                            <a href="#menu" className="hover:text-[#FFCBA0]" data-testid="footer-menu">
                                Menu
                            </a>
                        </li>
                        <li>
                            <a href="#about" className="hover:text-[#FFCBA0]" data-testid="footer-about">
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href="#contact" className="hover:text-[#FFCBA0]" data-testid="footer-contact">
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display text-lg font-bold">Order Directly</h4>
                    <p className="mt-4 text-sm text-white/70">
                        Tap below to open a WhatsApp chat with our kitchen.
                    </p>
                    <a
                        href={buildWaLink(
                            "Hi Kiraak Mandi! I'd like to place an order.",
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-press mt-4 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE53] text-white font-bold px-5 py-3 rounded-full text-sm"
                        data-testid="footer-whatsapp"
                    >
                        <WaIcon className="w-4 h-4" />
                        +968 7123 1343
                    </a>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
                <p data-testid="footer-copyright">
                    © {new Date().getFullYear()} {RESTAURANT_NAME}. All rights reserved.
                </p>
                <p>Crafted with fire & saffron.</p>
            </div>
        </footer>
    );
};

export default Footer;
